<template>
  <div >

    <!--智能客服-->
    <CustomerService/>

    <!--在线留言-->
    <OnlineMsg/>

    <div >

      <div class="nrMain" v-if="category==0">
        <!--筛选条件-->
        <div class="search">
          <a-form class="search-form" layout="inline" :model="search">
            <a-form-item style="text-align: right;">
              <a-input
                  v-model="search.produceName"
                  placeholder="请输入产品名称"
                  style="width: 300px; margin-right: 10px; height: 40px;vertical-align:middle;"
                  v-decorator="[
                                      'search.produceName',
                                      { rules: [{  message: '最少输入3个字符，最多输入10个字符', min: 3, max: 10 }] },
                                    ]"
              />
              <a-button type="primary" icon="search" style="height: 39px" @click="getProduces">
                搜索
              </a-button>
            </a-form-item>

            <a-form-item label="排序规则(单选)">
              <a-checkable-tag v-model="sort[0]" @change="selectSort(0)" style="font-size: medium;cursor: pointer;">
                不限
              </a-checkable-tag>
              <a-checkable-tag v-model="sort[1]" @change="selectSort(1)" style="font-size: medium;cursor: pointer;">
                利率由高到低
              </a-checkable-tag>
              <a-checkable-tag v-model="sort[2]" @change="selectSort(2)" style="font-size: medium;cursor: pointer;">
                融资金额由高到低
              </a-checkable-tag>
              <a-checkable-tag v-model="sort[3]" @change="selectSort(3)" style="font-size: medium;cursor: pointer;">
                融资期限由长到短
              </a-checkable-tag>
              <a-checkable-tag v-model="sort[4]" @change="selectSort(4)" style="font-size: medium;cursor: pointer;">
                申请笔数从多到少
              </a-checkable-tag>
              <a-checkable-tag v-model="sort[5]" @change="selectSort(5)" style="font-size: medium;cursor: pointer;">
                授信笔数从多到少
              </a-checkable-tag>
            </a-form-item>

            <a-form-item label="贷款渠道(多选)">
              <a-checkable-tag v-for="(item,key) in this.organization"
                               v-model="organization[key]"
                               :key="key"
                               style="font-size: medium;cursor: pointer;"
                               @change="selectOrganization(key)">
                {{key}}
              </a-checkable-tag>
            </a-form-item>

            <a-form-item label="担保方式(多选)">
              <a-checkable-tag v-for="(item,key) in this.guarantee"
                               v-model="guarantee[key]"
                               :key="key"
                               style="font-size: medium;cursor: pointer;"
                               @change="selectGuarantee(key)">
                {{key}}
              </a-checkable-tag>
            </a-form-item>

            <a-form-item label="贷款期限(单选)">
              <a-checkable-tag v-for="(item,index) in this.term"
                               v-model="term[index]"
                               :key="index"
                               style="font-size: medium;cursor: pointer;"
                               @change="selectTerm(index)"
              >
                {{index}}
              </a-checkable-tag>
            </a-form-item>

            <a-form-item label="贷款额度(单选)">
              <a-checkable-tag v-for="(item,index) in this.amount"
                               v-model="amount[index]"
                               :key="index"
                               style="font-size: medium;cursor: pointer;"
                               @change="selectAmount(index)"
              >
                {{index}}
              </a-checkable-tag>
            </a-form-item>

            <a-form-item label="行政区域(多选)">
              <a-checkable-tag v-for="(item,key) in this.region"
                               v-model="region[key]"
                               :key="key"
                               style="font-size: medium;cursor: pointer;"
                               @change="selectRegion(key)">
                {{key}}
              </a-checkable-tag>
            </a-form-item>
<!--            <a-form-item label="适用对象(单选)">-->
<!--              <a-checkable-tag v-for="(item,index) in this.type"-->
<!--                               v-model="type[index]"-->
<!--                               :key="index"-->
<!--                               style="font-size: medium;cursor: pointer;"-->
<!--                               @change="selectType(index)">-->
<!--                {{index}}-->
<!--              </a-checkable-tag>-->
<!--            </a-form-item>-->
            <a-form-item label="特色专区(单选)">
              <a-checkable-tag v-for="(item,index) in this.ts"
                               v-model="ts[index]"
                               :key="index"
                               style="font-size: medium"
                               @change="selectTs(index)">
                {{index}}
              </a-checkable-tag>
            </a-form-item>
          </a-form>
        </div>
      </div>

      <div class="nrMain">
        <!--结果统计-->
        <div class="resultTotal">
          <p>
            <a-icon type="switcher" />
            根据您的需求，一共为您找到<span>{{productList.length}}</span>件金融产品
          </p>
        </div>
        <!--结果列表-->
        <div class="result">
          <a-spin :spinning="spinning" tip="搜索中....">
            <a-list item-layout="vertical" size="large" :data-source="productList" :pagination="pagination" >
              <a-list-item class="pro_bg"
                           slot="renderItem" key="item.id" slot-scope="item" @click="listClick(item.id)">
                <!--                        <div class="cs4_12_cp1">-->
                <!--                            <img src="../assets/img/hz41.png">-->
                <!--                        </div>-->
                <!--                        <div class="cs4_12_cp2">-->
                <!--                            <span class="cs4_12_5_wz0">“百合花”小额自助循环贷款</span><br>-->
                <!--                            <span class="cs4_12_5_wz4">无担保信用贷款</span>-->
                <!--                        </div>-->
                <!--                        <div class="cs4_12_cp3">-->
                <!--                            <span class="cs4_12_5_wz1">4.35-6.5%</span><br><img src="img/hz33.png"><span class="cs4_12_5_wz3">年息范围</span>-->
                <!--                        </div>-->
                <!--                        <div class="cs4_12_cp4">-->
                <!--                            <span class="cs4_12_5_wz2">1-24（月）</span><br><img src="img/hz34.png"><span class="cs4_12_5_wz3">贷款期限</span>-->
                <!--                        </div>-->
                <!--                        <div class="cs4_12_cp5">-->
                <!--                            <span class="cs4_12_5_wz2">1-100（万元）</span><br><img src="img/hz35.png"><span class="cs4_12_5_wz3">额度范围</span>-->
                <!--                        </div>-->
                <div class="proImg">
                  <img :src="downPath+item.logo"  height="30px">
                </div>
                <div class="proName">
                  <div style="font-size: 20px;font-weight: 600;margin-bottom: 5px;">
                    {{item.productName}}
                  </div>
                  <div>
                    适用对象：{{item.type}}
                  </div>
                </div>
                <div class="proList">
                  <div class="proRate">
                    <div style="font-size: large; color: #1492ff" v-if="item.rateMin == 0 && item.rateMax != 0">
                      不高于{{ item.rateMax }}%
                    </div>
                    <div style="font-size: large; color: #1492ff" v-else-if="item.rateMin != 0 && item.rateMax == 0">
                      {{ item.rateMin }}%起
                    </div>
                    <div style="font-size: large; color: #1492ff" v-else-if="item.rateMin == 0 && item.rateMax == 0">
                      面议
                    </div>
                    <div class="proNum" style="color: #1492ff" v-else>
                      {{ item.rateMin }}~{{ item.rateMax }}%
                    </div>

                    <div class="proList">
                      <img src="../assets/img/hz33.png">
                      <span v-if="category == 2">保费费率</span>
                      <span v-else>年利率（单利）</span>
                    </div>
                  </div>
                  <div class="proDeadLine">
                    <div class="proNum" style="color: #fa8c16">
                      {{item.loanDeadlineMin}}-{{item.loanDeadlineMax}}（月）
                    </div>
                    <div class="proList">
                      <img src="../assets/img/hz34.png">
                      <span v-if="category == 1">担保期限</span>
                      <span v-if="category == 2">承保期限</span>
                      <span v-if="category == 0">贷款期限</span>
                    </div>
                  </div>
                  <div class="proAmount">
                    <div class="proNum" style="color: #4AC3BF">
                      {{item.loanMin}}-{{item.loanMax}}（万元）
                    </div>
                    <div class="proList">
                      <img src="../assets/img/hz35.png">
                      <span v-if="category == 2">保额范围</span>
                      <span v-else>额度范围</span>

                    </div>
                  </div>
                </div>
              </a-list-item>
            </a-list>
          </a-spin>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {getGuarantee,search,getTypes} from '@/api/finance/finance'
import {userStatus} from "@/api/user"
import {mapState} from "vuex";
import CustomerService from "@/components/customerService/customerService";
import OnlineMsg from "@/components/onlineMessage/OnlineMessage";

const formItemLayout = {
  labelCol: { span: 4 },
};
export default {
  components: {
    CustomerService,
    OnlineMsg
  },
  name: "IndexProduct",
  computed: {
    ...mapState(["downPath"]),
  },
  data() {
    return {
      formItemLayout,
      productList: [],
      rules: {
        produceName: [
          {
            required: true,
            message: '请输入产品名称'
          },
          {
            min: 3,
            max: 20,
            whitespace: true
          }
        ]
      },
      search: {
        produceName: "",
        sort: 0,
        organization: [],
        guarantee: [],
        term: "不限",
        amount: "不限",
        type: "",
        region: [],
        yxdwId:0,
        rate:0
      },
      guarantee: {
        "不限": true,
        "抵押": false,
        "质押": false,
        "信保基金": false,
        "一般保证": false,
        "信用": false,
        "保证": false,
        "连带责任保证": false,
      },
      organization: {
        "不限": true,
        "银行": false,
        "担保公司": false,
        "保险公司": false,
        "小额贷款公司": false,
        "融资租赁公司": false,
        "保理公司": false,
        "风险投资机构": false,
        "消费金融公司": false,
        "资产管理公司": false,
        "信托公司": false,
        "其他": false,
      },
      term: {
        "不限": false,
        "12个月（含）以下": false,
        "12~36个月（含）以下": false,
        "36~60个月（含）以下": false,
        "60个月以上": false,
      },
      amount: {
        "不限": false,
        "30万以下": false,
        "30~100万": false,
        "100~300万": false,
        "300~500万": false,
        "500万以上": false,
      },
      type: {
        "不限": true,
        "企业": false,
        "个人": false,
      },
      ts: {
        "不限": true,
        "乡村振兴": false,
        "科技创新": false,
        "人才引进": false,
      },
      region: {},
      sort: [true, false, false, false, false, false, false],
      checked2: false,
      spinning: false,
      category: 0,
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: page => {
          this.pageChange(page);
        },
      },
      selectedTags: [],
      account: {},
    }
  },

  beforeRouteEnter(to, from, next) {
    userStatus()
        .then(res => {
              next(vm => {
                // console.log("account:", res.data.success)
                vm.account = res.data.data.account;
              })
        })
    getTypes("003006")
        .then(res => {
          next(vm => {
            vm.$ajaxAfter(res).then(() => {
              vm.region["不限"] = true;
              res.data.data.list.forEach(resp=>{
                vm.region[resp.desc] = false;
              })
            });
            if(to.query.type){
              console.log(to.query.type);
              vm.category=to.query.type;
            }
            if(to.query.amount){
              vm.search.amount=to.query.amount;
              vm.amount[to.query.amount] = true;
            }else{
              vm.amount["不限"] = true;
            }
            if (vm.account.roleType === "6") {
              vm.search.type = "个人";
            } else {
              vm.search.type = "企业";
            }
            if(to.query.term){
              vm.search.term=to.query.term;
              vm.term[to.query.term] = true;
            }else{
              vm.term["不限"] = true;
            }
            if(to.query.yxdwId){
              vm.search.yxdwId=to.query.yxdwId;
            }
            if(to.query.guarantee){
              vm.guarantee[to.query.guarantee] = true;
              vm.selectGuarantee(to.query.guarantee);
              vm.search.guarantee= [to.query.guarantee];
            }else{
              vm.guarantee["不限"] = true;
            }
            if(to.query.loan){
              vm.search.rate = parseFloat(to.query.loan);
            }
            vm.getProduces();
          });
        })
        .catch(() => {

        });
  },

  methods: {
    //选择排序方式
    selectSort(index) {
      for (let indexKey in this.sort) {
        if (indexKey != index){
          this.sort[indexKey] = false;
        }else {
          this.search.sort = indexKey;
        }
      };
      this.getProduces(true);
    },
    //选择贷款渠道
    selectOrganization(guarantee) {
      if (guarantee == "不限") {
        for (let item in this.organization) {
          if (item != guarantee) {
            this.organization[item] = false;
          }
        }
      }else {
        this.organization["不限"] = false;
      }
      let temp = [];
      for (let key in this.organization){
        if (this.organization[key] == true){
          temp.push(key);
        }
      }
      this.search.organization = temp;
      this.getProduces(true);
    },
    //选择担保方式
    selectGuarantee(guarantee) {
      if (guarantee == "不限") {
        for (let item in this.guarantee) {
          if (item != guarantee) {
            this.guarantee[item] = false;
          }
        }
      }else {
        this.guarantee["不限"] = false;
      }
      let temp = [];
      for (let key in this.guarantee){
        if (this.guarantee[key] == true){
          temp.push(key);
        }
      }
      this.search.guarantee = temp;
      this.getProduces(true);
    },
    //选择期限
    selectTerm(index) {
      for (let indexKey in this.term) {
        if (indexKey != index){
          this.term[indexKey] = false;
        }else {
          this.search.term = indexKey;
        }
      };
      let temp = 0;
      for (let indexKey in this.term) {
        if (this.term[indexKey]){
          temp += 1;
        }
      };
      if (temp == 0){
        this.search.term = "不限";
      }
      this.getProduces(true);
    },
    //选择额度
    selectAmount(index) {
      for (let indexKey in this.amount) {
        if (indexKey != index){
          this.amount[indexKey] = false;
        }else {
          this.search.amount = indexKey;
        }
      };
      let temp = 0;
      for (let indexKey in this.amount) {
        if (this.amount[indexKey]){
          temp += 1;
        }
      };
      if (temp == 0){
        this.search.amount = "不限";
      }
      this.getProduces(true);
    },
    //选择行政区域
    selectRegion(region) {
      if (region == "不限") {
        for (let item in this.region) {
          if (item != region) {
            this.region[item] = false;
          }
        }
      }else {
        this.region["不限"] = false;
      }
      let temp = [];
      for (let key in this.region){
        if (this.region[key] == true){
          temp.push(key);
        }
      }
      this.search.region = temp;
      this.getProduces(true);
    },
    //选择适用对象
    // selectType(index) {
    //   for (let indexKey in this.type) {
    //     if (indexKey != index){
    //       this.type[indexKey] = false;
    //     }else {
    //       this.search.type = indexKey;
    //     }
    //   };
    //   let temp = 0;
    //   for (let indexKey in this.type) {
    //     if (this.type[indexKey]){
    //       temp += 1;
    //     }
    //   };
    //   if (temp == 0){
    //     this.search.type = "不限";
    //   }
    //   this.getProduces(true);
    // },
    //选择适用对象
    selectTs(index) {
      for (let indexKey in this.ts) {
        if (indexKey != index){
          this.ts[indexKey] = false;
        }else {
          if(indexKey=='乡村振兴'){
            this.search.produceName = '农';
          }else if(indexKey=='科技创新'){
            this.search.produceName = '科';
          }else if(indexKey=='人才引进'){
            this.search.produceName = '人才';
          }else{
            this.search.produceName='';
          }

        }
      };
      let temp = 0;
      for (let indexKey in this.ts) {
        if (this.ts[indexKey]){
          temp += 1;
        }
      };
      if (temp == 0){
        this.search.produceName='';
      }
      this.getProduces(true);
    },
    //获取金融产品
    getProduces(resetPage) {
      this.spinning = true;
      if (resetPage) {
        this.pagination.current = 1;
      }
      let formData = new FormData();
      formData.append("sort", this.search.sort);
      formData.append("dw", this.search.organization);
      formData.append("guarantee", this.search.guarantee);
      formData.append("rate", this.search.rate);
      formData.append("region", this.search.region);
      formData.append("amount", this.search.amount);
      formData.append("loanDeadline", this.search.term);
      formData.append('produceName', this.search.produceName);
      formData.append('type', this.search.type);
      formData.append('yxdwId', this.search.yxdwId);
      formData.append('page', this.pagination.current);
      formData.append('productType', this.category == 1 ? "担保产品" : (this.category == 2) ? "保险产品" : "");
      search(formData).then(res => {
        this.$ajaxAfter(res).then( ()=> {
          if (res.data.success == "TRUE") {
            this.productList = res.data.data.producesList;
          } else {
            this.$message.error(res.data.message);
          }
          this.spinning = false;
        })
      }).catch(() => {
        this.$message.error("服务器出错！请稍后再试!");
      });
    },

    //换页
    pageChange(page) {
      this.pagination.current = page;
    },
    listClick(id){
      //this.$router.push({ name: "financeProduct_detail", query: {id: id} });
      const {href} = this.$router.resolve({
        name: "financeProduct_detail", query: {id: id}
      });
      window.open(href, '_blank');
    },
  },
}
</script>

<style scoped lang="less">
.background{
  width: 100%;
  background-color: #f5f5f5;
  position: relative;
  z-index: 1;
  margin: 102px 0 20px 0;
}
.nrbj{
  width: 100%;
  height: 360px;
  position: absolute;
  z-index: 3;
  top: 0;
}

.nrBox{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 5;
  padding-top: 50px;
}

.jsbanner{
  display: block;
  width: 684px;
  margin: 0 auto;
  margin-bottom: 30px;
}

.nrMain{
  width: 100%;
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
}

.search{
  width: 100%;
  min-height: 300px;
}

.search-form .ant-form-item{
  font-weight: bold;
  width: 100%;
  border-bottom: solid 1px WhiteSmoke;
  padding: 5px 0;
  margin-bottom: 20px;
}
.search-form .ant-form-item:nth-child(1){
  border-bottom: 0;
}
/deep/ .search .ant-form label{
  font-size: 16px;
}

.condition2 {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
}

.resultTotal{
  width: 100%;
  height: 40px;
  background-color: rgba(20,146,255,0.05);
  border: solid 1px #1492ff;
  border-radius: 5px;
  padding: 0 10px;
  margin-bottom: 30px;

  p{
    font-size: 14px;
    line-height: 40px;

    i{
      font-size: 16px;
      color: #1492ff;
    }

    span{
      color: #1492ff;
      font-family: 'DIN_Condensed_Bold';
      font-size: 16px;
      margin: 0 5px;
    }
  }
}

.result{
  width: 100%;

  /deep/ .ant-list-items{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.pro_bg{
  width: 49%;
  border: solid 1px #eeeeee;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
.dd5{
  height: 99px;
  width: 100%;
  background: #383d41;margin:0 auto;
}
.dd5_copyright{
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding-top:40px;
}


.font1 {
  font-size: small;
  font-weight: bolder;
  color: #3bb6f7;
}

.font2 {
  font-size: x-large;
  font-weight: bolder;
}

.proImg {
  width: 100%;
  margin-bottom: 20px;
}

.proName {
  width: 100%;
  color: #333333;
  line-height: 30px;
  margin-bottom: 20px;
}

.proList{
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}

.proRate {
  width: 33.3%;
}

.proDeadLine {
  width: 33.3%;
}

.proAmount {
  width: 33.3%;
}

.proList{
  color: #333333;
  font-size: 14px;
  margin-top: 10px;

  img{
    float: left;
    margin: 3px 5px 0 0;
  }
}

.proNum{
  font-family: 'DIN_Condensed_Bold';
  font-size: 20px;
}

</style>
